import React from 'react'
import type { Icon } from 'shared/utils'

const Family = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'family',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            {...otherProps}>
            <g transform="translate(2 2)" fill={color} fillRule="nonzero">
                <path d="M12.159 15.127h-4.53c-.829 0-1.503.674-1.503 1.503v3.51h7.536v-3.51c0-.83-.674-1.503-1.503-1.503z" />
                <path d="M17.773 7.053h-2.029a3.363 3.363 0 002.176-1.717h.92C18.84 2.39 17.218 0 14.989 0c-2.23 0-3.852 2.39-3.852 5.336h.92a3.363 3.363 0 002.175 1.717h-2.12c-.984 0-1.816.638-2.112 1.522A2.227 2.227 0 007.89 7.053H5.86c1.48-.357 2.586-1.736 2.586-3.387 0-1.922-1.496-3.48-3.342-3.48-1.845 0-3.34 1.558-3.34 3.48 0 1.65 1.104 3.03 2.585 3.387H2.227C.997 7.053 0 8.05 0 9.281v10.858h5.569v-3.51c0-1.135.924-2.06 2.06-2.06h.505a3.089 3.089 0 01-1.154-2.431c0-1.69 1.324-3.064 2.951-3.064 1.628 0 2.952 1.375 2.952 3.064 0 .982-.443 1.868-1.155 2.431h.43c1.137 0 2.061.925 2.061 2.06v3.51H20V9.281c0-1.23-.997-2.228-2.227-2.228z" />
                <ellipse cx={9.915} cy={12.17} rx={2.32} ry={2.538} />
            </g>
        </svg>
    )
}

export { Family }
